/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import { LogLevel } from "@azure/msal-browser";
// require('dotenv').config()
const ua = window.navigator.userAgent;
const msie = ua.indexOf("MSIE ");
const msie11 = ua.indexOf("Trident/");
const msedge = ua.indexOf("Edge/");
const firefox = ua.indexOf("Firefox");
const isIE = msie > 0 || msie11 > 0;
const isEdge = msedge > 0;
const isFirefox = firefox > 0;
/**
 * Enter here the user flows and custom policies for your B2C application
 * To learn more about user flows, visit: https://docs.microsoft.com/en-us/azure/active-directory-b2c/user-flow-overview
 * To learn more about custom policies, visit: https://docs.microsoft.com/en-us/azure/active-directory-b2c/custom-policy-overview
 */
export const b2cPolicies = {
    names: {
        signUpSignIn: "B2C_1_signupsignin1",
        forgotPassword: "B2C_1_forgotpassword1",
        editProfile: "B2C_1_profileedit1"
    },
    authorities: {
        signUpSignIn: {
            authority: "https://AndtrTento.b2clogin.com/AndtrTento.onmicrosoft.com/B2C_1A_DEMO_SIGNUP_SIGNIN_SPLITEMAILVERIFICATIONANDSIGNUP",
        },
        forgotPassword: {
            authority: "https://AndtrTento.b2clogin.com/AndtrTento.onmicrosoft.com/B2C_1_forgotpassword1",
        },
        editProfile: {
            authority: "https://AndtrTento.b2clogin.com/AndtrTento.onmicrosoft.com/B2C_1_profileedit1"
        }
    },
    authorityDomain: "AndtrTento.b2clogin.com"
}

const CLIENT_ID = process.env.REACT_APP_STAGE === 'stage'
        ? "cc0ded1b-dd50-445d-96d2-766e51b2caf4"
        : process.env.REACT_APP_STAGE === 'production' ? "711b662a-2ef8-47a7-9d10-fa90afc724e1" : "a580012c-66c4-474c-b186-8d4634397a60";
/**
 * Configuration object to be passed to MSAL instance on creation. 
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md 
 */
export const msalConfig = {
    auth: {
        // clientId: "711b662a-2ef8-47a7-9d10-fa90afc724e1", // for Production This is the ONLY mandatory field that you need to supply.
        clientId: CLIENT_ID, // for local development
        //  clientId: "cc0ded1b-dd50-445d-96d2-766e51b2caf4", // for staging
        authority: b2cPolicies.authorities.signUpSignIn.authority, // Choose SUSI as your default authority.
        knownAuthorities: [b2cPolicies.authorityDomain], // Mark your B2C tenant's domain as trusted.
        redirectUri: `${window.location.origin}/`, // You must register this URI on Azure Portal/App Registration. Defaults to window.location.origin
        postLogoutRedirectUri: "/", // Indicates the page to navigate after logout.
        navigateToLoginRequestUrl:false, // If "true", will navigate back to the original request location before processing the auth code response.
    },
    cache: {
        cacheLocation: "localStorage", // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {
        allowRedirectInIframe: true,
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    case LogLevel.Info:
                        console.info(message);
                        return;
                    case LogLevel.Verbose:
                        console.debug(message);
                        return;
                    case LogLevel.Warning:
                        console.warn(message);
                        return;
                    default:
                        return;
                }
            }
        }
    }
};

/**
 * Add here the endpoints and scopes when obtaining an access token for protected web APIs. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
export const protectedResources = {
    apiHello: {
        endpoint: "http://localhost:5000/hello",
        scopes:  ["https://AndtrTento.onmicrosoft.com/7006505a-4379-4e92-9be7-f1dfb1a533b0/User.Read",
        "https://AndtrTento.onmicrosoft.com/7006505a-4379-4e92-9be7-f1dfb1a533b0/user.read"],
        forceRefresh: true,
        // ["https://AndtrTento.onmicrosoft.com/7006505a-4379-4e92-9be7-f1dfb1a533b0/demo.read"], // e.g. api://xxxxxx/access_as_user
    },
}

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit: 
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
//  export const loginRequest = {
//     scopes: [...protectedResources.apiHello.scopes]
// };

export const loginRequest = {
    scopes: ["https://AndtrTento.onmicrosoft.com/7006505a-4379-4e92-9be7-f1dfb1a533b0/User.Read",
    "https://AndtrTento.onmicrosoft.com/7006505a-4379-4e92-9be7-f1dfb1a533b0/user.read"],
    forceRefresh: true,
    redirectUri: window.location.href

};
export const graphConfig = {
    graphMeEndpoint: "https://graph.microsoft.com/v1.0/me"
};